import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-5xl px-4 py-8 mx-auto mt-8 border shadow-sm bg-white rounded-3xl border-clay-500 sm:px-10" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "space-y-1" }
const _hoisted_4 = { class: "max-w-2xl pt-6 font-bold text-clay-900" }
const _hoisted_5 = { class: "text-clay-800" }
const _hoisted_6 = { class: "py-3 mt-3 text-center" }

import {computed, onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {
    GetAllTerritories, GetProfileRegion, GetProfileRegionResponse,
    Region, UpdateProfileRegion
} from "@/dtos";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import TerritoriesTab from "../Territories/TerritoriesTab.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingStepRegion',
  emits: ['onNext', 'onBack'],
  setup(__props, { emit: __emit }) {

// @ts-ignore
const responseStatus = ref(null);

const updateSuccessful = ref(false);
const territories = ref(new Array<Region>());

const defaultAssignedRegion = ref(new Region());

const territoryQuery = ref('');

onMounted(async () => {
    await client.get<Array<Region>>(new GetAllTerritories())
        .then(res => {
            territories.value = res.sort((a:Region, b:Region) => a.name.localeCompare(b.name));
        });

    await client.get<GetProfileRegionResponse>(new GetProfileRegion())
        .then(res => {
            defaultAssignedRegion.value = res.closestRegionForUser
        });
});

const filteredTerritories = computed(() =>
    territoryQuery.value === ''
        ? territories.value
        : territories.value.filter((territory: Region) => {
                return territory.name.toLowerCase().includes(territoryQuery.value.toLowerCase())
            }
        )
)

const emit = __emit;

const next = async () => {
    updateSuccessful.value = false;

    await client.post(new UpdateProfileRegion({territoryId: defaultAssignedRegion.value.id}))
        .then(() => {
            emit('onNext');
        })
}

const skip = async () => emit('onNext');

const onRegionSelected = (territory: Region) => {
    defaultAssignedRegion.value = territory;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ErrorSummary, { "response-status": responseStatus.value }, null, 8, ["response-status"]),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "sm:mx-auto sm:w-full sm:max-w-md" }, [
      _createElementVNode("h1", { class: "mt-6 text-3xl font-bold tracking-tight text-center text-gray-900" }, "What is your closest metro area?"),
      _createElementVNode("h2", { class: "mt-2 text-lg text-center text-gray-600" }, "Select your nearest location so we can show you relevant auditions, performances and classes.")
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, [
            _cache[2] || (_cache[2] = _createTextVNode("It looks like your nearest major metro area is ")),
            _createElementVNode("span", _hoisted_5, _toDisplayString(defaultAssignedRegion.value.name), 1),
            _cache[3] || (_cache[3] = _createTextVNode("."))
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "max-w-2xl" }, "Don't worry about including your exact location, just the select the closest city.", -1))
        ])
      ]),
      _createVNode(TerritoriesTab, {
        territories: territories.value,
        modelValue: defaultAssignedRegion.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((defaultAssignedRegion).value = $event)),
        onOnRegionSelected: onRegionSelected
      }, null, 8, ["territories", "modelValue"]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "w-full inline-flex items-center justify-center px-4 py-[calc(theme(spacing.2)-1px)] rounded-full border border-transparent bg-electric-600 shadow-md whitespace-nowrap text-base font-medium text-white data-[disabled]:bg-clay-50 data-[hover]:bg-electric-500 data-[disabled]:text-clay-500",
          type: "submit",
          onClick: _withModifiers(next, ["prevent"])
        }, " Next "),
        _createElementVNode("button", {
          class: "justify-center hidden w-full px-4 py-2 mt-4 text-sm text-gray-600 underline hover:no-underline",
          onClick: _withModifiers(skip, ["prevent","stop"])
        }, " Skip ")
      ]),
      _createElementVNode("button", {
        class: "justify-center w-full px-4 py-2 mt-4 text-sm text-gray-600 underline hover:no-underline",
        type: "submit",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => {emit('onBack');}, ["prevent"]))
      }, " Back ")
    ]),
    _createVNode(NotificationSuccess, {
      show: updateSuccessful.value,
      content: "Your changes were successfully saved.",
      title: "Successfully saved!"
    }, null, 8, ["show"])
  ], 64))
}
}

})